'use strict'

var Q = require('q');
const fetch = require('node-fetch');
//const URLSearchParams = require('url').URLSearchParams
var FormData = require('form-data');
//var Canvas = require('canvas'), Image = Canvas.Image;
var sharp = require('sharp');
var fs = require('fs');
var channels = 4;
const Kmin_accuracy = 0.72;
var MIN_A = 0.72;

exports.analyzeImage = async function (pixels, config, callback, debugImage) {
  console.log("ML analyzeImage", config);
  try {
    var digits = config.digits.positions;
    console.log("digits length", digits.length);
    console.log("document", typeof (document));
    MIN_A = config.digits.minAccuracy ? config.digits.minAccuracy : Kmin_accuracy;
    //console.log("pixels:", pixels);
    //var width = 640;
    //var height = 480;
    //canvas.style.id = "targetCanvas";
    //canvas.width  = width;
    //canvas.height = height;
    //var sourceImageData = context.createImageData(width, height);
    //var data = sourceImageData.data;
    // copy pixels to ImgData
    fs.readFile(config.file, async function (err, rotImg) {
      //if (err) throw err;
      //var img = new Image;
      //img.src = rotImg;
      //var canvas = new Canvas(img.width, img.height);//document.createElement('canvas');
      //var context = canvas.getContext("2d");
      //context.drawImage(img, 0, 0, img.width, img.height);

      //console.log("Debug1");
      //for (var i = 0, len = width * height * channels; i < len; i++) {
      //    data[i] = pixels.data[i];
      //}

      // draw original source to canvas
      //context.putImageData(sourceImageData, 0, 0);
      //var img=new Image();
      //img.src=canvas.toBuffer();
      let image= await sharp(rotImg);
      //image.toFile('/lcp/filetransfer/2.jpg');
      //console.log("Debug2");
      var promises = [];
      for (var i = 0; i < digits.length; i++) {
        var digit = digits[i];
        let cordsWidth = digit.coords[2] - digit.coords[0];
        let cordsHeight = digit.coords[3] - digit.coords[1];
        console.log("ml debug image box width:", cordsWidth);
        console.log("ml debug image box height:", cordsHeight);
        let croppedDigit= await image.extract({left:digit.coords[0],top:digit.coords[1], width: cordsWidth, height:cordsHeight}).toBuffer();//.toFile('/lcp/filetransfer/1.jpg');//.toBuffer();
        let b64 = croppedDigit.toString('base64').replace(/\+/g, '-').replace(/\//g, '_');
        //console.log("b64:",b64);
        await getDigit(i,digit,b64);
      }
      if (!callback) return { digits: digits };
        setTimeout(function () {
          callback(null, { digits: digits });
        }, 1)
      /*Q.all(promises).then(function (results) {
        console.log("All promises done!");
        console.log("results:",results);
        console.log("ml debug done:", digits);
        if (!callback) return { digits: digits };
        setTimeout(function () {
          callback(null, { digits: digits });
        }, 1)
      })*/
    })
  } catch (err) {
    console.log("ANALYZE ERROR:", err);
    if (!callback) return { digits: digits };
        setTimeout(function () {
          callback(null, { digits: digits });
        }, 1)
  }

}

function getDigit(i, digit, img) {
  let ind = i;
  const formdata = new FormData();
 //img = img.replace(/\+/g, '-');
  //img = img.replace(/\//g, '_');
  //let formdata={b64: b64};
  formdata.append('b64', img);
  return fetch('http://localhost:5000/imageclassifier/predict/',
    {
      method: 'POST',
      body: formdata
    }).then(function (res) {
      if(res.ok){
      return res.json().then(function (resul) {
        try {
          //response=JSON.parse(res);
          console.log("res:", resul);
          let mlres = resul.predictions.detection_class === 10 ? -1 : resul.predictions.detection_class;
          let mlaccu = resul.predictions.detection_score.toFixed(2)/100;
          digit.result=mlres;
          digit.reliability=mlaccu;
    	  if (digit.reliability < MIN_A) {
     	   	console.log("Accuracy too low:",digit.reliability);
		digit.result = -1;
	  }
          console.log("index:",ind);
          console.log("Result:", mlres);
          console.log("Accuracy:", mlaccu + '%');
          console.log("digit id:", digit)
          return digit;

        } catch (err) {
          console.log("Vituxsmän:", err);
          return digit;
        }
      })
      }
      else{
        digit.result=-3;
        digit.reliability=-1;
        return digit;
      }
    }).catch(err => console.log("Fetch err",err));
}



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/mlreader1.js
// module id = 844
// module chunks = 0